import { Pipe, PipeTransform } from '@angular/core';
import {parseLocal} from "../util/parse-local-timezone";

@Pipe({
  name: 'dateTimezone',
})
export class DateTimezonePipe implements PipeTransform {
  transform(value: any) {
    if (!value) {
      return null;
    }
    if (typeof value.toLocalDate === 'function') {
      return value.toLocalDate();
    }
    if (typeof value !== 'string') {
      console.warn('ignorarTimezone: não é uma string de data ISO:', value);
      return value;
    }

    return parseLocal(value).date;
  }
}
